<script>
  import { countries, euCountries, gdpr } from '../constants';
  import { sanitizeDomain, validateDomain, hubspotLeadSubmit } from '../util';
  import { domainName, record } from '../stores.js';
  import { bimiLookup } from '../api.js';
  import { onMount } from 'svelte';

  let error = false;
  let loading = false;
  let inputDomainName = '';
  let inputEmail = '';
  let inputCountry = '';
  let validForm = null;
  let formGUID = '56cf831b-1c38-4b23-837f-2419f0fbccde';
  let hubspotutk = '';
  let url = '';

  onMount(async () => {
    url = window.location.href;
    //console.log('page url = ' + url);

    hubspotutk = getHubspotUtkCookie();
    //console.log('hubspotutk = ' + hubspotutk);
  });

  $: validDomain = validateDomain(inputDomainName);
  $: isEUCountry = euCountries.includes(inputCountry);

  function lookupDomain() {
    inputDomainName = sanitizeDomain(inputDomainName);

    validForm = inputDomainName != '' && inputEmail != '' && inputCountry != '';
    error = false;

    if (!validForm) return;

    if (validateDomain(inputDomainName)) {
      loading = true;
      let formValues = {
        'bimi_domain': inputDomainName,
        'email': inputEmail,
        'bimi_record_status': 'Record Found',
        'dmarc_record_status': 'Record Found',
        'country': inputCountry,
      };

      
      let context = {
        "hutk": hubspotutk, // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
        "pageUri": url,
        "pageName": "Bimi Lookup"
      };
      

      if (isEUCountry) {
        let gdprValues = [];
        Object.values(gdpr).forEach(item => {
          if (item.value == true) {
            gdprValues.push(item.text);
          }
        });
        formValues.gdpr_contact_methods = gdprValues.join('; ');
      }

      bimiLookup(inputDomainName).catch(err => {
        error = err.message;
        formValues.bimi_record_status = 'Record Not Found';
        formValues.dmarc_record_status = 'Record Not Found';
      });

      console.log(formValues);
      // Hubspot background submit.
      // @see https://developers.marketo.com/blog/make-a-marketo-form-submission-in-the-background/
      hubspotLeadSubmit(formValues, context, formGUID);
    }
  }

  const getHubspotUtkCookie = () => {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'hubspotutk') {
        return value;
      }
    }
    return null;
  };
</script>

<section class="tool-banner tool-banner-bimi mb-5">
  <div class="banner"></div>
  <div class="row-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 m-auto">
          <div class="result-box">
            <form
              on:submit|preventDefault={lookupDomain}
              class="bimi-search"
            >
              <div class="search-row">
                <div class="left">
                  <div class="mb-3">
                    <input
                      bind:value={inputDomainName}
                      class="form-control form-control-lg"
                      name="domain_name"
                      placeholder="Enter your domain here..."
                      maxlength="255"
                      type="text"
                      title="Enter a fully qualified domain name"
                    >
                  </div>
                  <div class="mb-3">
                    <input
                      bind:value={inputEmail}
                      class="form-control form-control-lg"
                      name="email"
                      placeholder="Email address"
                      maxlength="255"
                      type="email"
                      required
                    >
                  </div>
                </div>
                <div class="right">
                  <div class="mb-3">
                    <select
                      bind:value={inputCountry}
                      class="form-control form-control-lg"
                      aria-label="Country"
                      required
                    >
                      <option value="" selected>Country</option>
                      {#each countries as country }
                        <option value={country}>{country}</option>
                      {/each}
                    </select>
                  </div>
                  {#if isEUCountry}
                    <div class="mb-3">
                      <p>We will use your data to provide you with information regarding your request. From time to time, we would like to contact you about our products and services, along with other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick the options below.</p>
                      {#each Object.entries(gdpr) as [id, item]}
                        <div class="form-check">
                          <input bind:checked={item.value} class="form-check-input" type="checkbox" id="{id}">
                          <label class="form-check-label" for="{id}">
                            {item.text}
                          </label>
                        </div>
                      {/each}
                    </div>
                  {/if}
                  <div class="text-center">
                    <button
                      disabled={!validDomain || loading}
                      class:loading
                      class="btn btn-lg btn-1 mx-auto"
                      type="submit"
                    >
                      Find Record
                    </button>
                  </div>
                  {#if inputDomainName != '' && !validDomain}
                    <div class="text-danger">Invalid domain name.</div>
                  {/if}
                  {#if validForm != null && !validForm}
                    <div class="text-danger">All fields are required.</div>
                  {/if}
                  {#if error}
                    <div class="text-danger">Invalid domain name.</div>
                  {/if}
                </div>
                
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



<!-- <section class="section row bg-7">
	<div class="col-sm-12">
		<div class="container">
			<h2 class="section-title">
				BIMI Brand Authentication
			</h2>
			<p class="text-center">Take the BIMI crash course before email fraudsters crash your party</p>
			<p class="text-center mt-5"><a href="/resources/videos/bimi-crash-course" class="btn btn-1">Free BIMI Course</a></p>
		</div>
	</div>
</section> -->

<style>

</style>
